const barColor = "rgba(0, 61, 166, 1)";

const frameworkD7Options = {
  maintainAspectRatio: false,
  plugins: {
    tooltip: {
      callbacks: {
        label: function(context){
          return context.parsed.y+"%"
        }
      }
    },
    datalabels: {
      display: false
    },
    title: {
      display: true,
      text: "Attribute: Acquisition of Capabilities",
      font: {
        size: 15
      }
    },
    legend: {
      display: false
    }
  },
  scales: {
    y: {
      min: 0,
      max: 100,
      title: {
        display: true,
        text: "Accuracy"
      },
      ticks: {
        callback: function(value, index, values) {
          return value+"%";
        }
      }
    },
    x: {
      title: {
        display: true,
        text: "System"
      }
    }
  },
};

const frameworkD7Data = {
  labels: ["Aegis", "AGZ", "Caster", "C-Core", "FIQ", "SCORE", "SRD"],
  datasets: [
    {
      data: [58, 67, 60, 15, 54, 37, 29.6],
      backgroundColor: barColor,
      borderColor: barColor,
      borderWidth: 1,
    },
  ],
}

export {frameworkD7Data, frameworkD7Options};
